import avatar from './avatar5.png';
const Hero = () => {
    return ( 
        <div className="hero">
            <div className='avatar-container'>
            <img className='avatar-mobile' src={avatar} />
            </div>
           <div className='heroText'>
           <h1 className="Name">
            Hi 👋 I'm Jawad!
            </h1>
            <p> I'm a Web developer and i create  websites that sky rocket brands ideas⚡.<br/>  I also write about tech and lifestyle on my weekends off.</p>
            <div className="links">
            <a  href="" style={{
            color:'white',
            backgroundColor:'#0b0b0b',
            borderRadius:'5px'
        
            }}>Contact Me</a>
            </div>
            {/* <div className="socio">
                <img src={discord} />
                <img src={github} />
                <img src={twitter} />
            </div> */}
           </div>
           <div className='avatar-container'>
            <img className='avatar-desktop' src={avatar} />
            </div>
            
        </div>
     );
}
 
export default Hero;